// extracted by css-extract-rspack-plugin
export default {"point":"point-bMW96u","labelWrapper":"labelWrapper-J4JSj1","label":"label-cmth4Y","tail":"tail-UD0dv4"};